import { useEffect, useCallback } from 'react';

export const useSidebarEffects = (isOpen, setIsOpen) => {
    const handleEscKey = useCallback((event) => {
        if (event.key === 'Escape' && isOpen) {
            setIsOpen(false);
        }
    }, [isOpen, setIsOpen]);

    useEffect(() => {
        document.addEventListener('keydown', handleEscKey);
        return () => document.removeEventListener('keydown', handleEscKey);
    }, [handleEscKey]);

    useEffect(() => {
        const originalStyle = {
            overflow: document.body.style.overflow,
            touchAction: document.body.style.touchAction
        };

        if (isOpen) {
            document.body.style.overflow = 'hidden';
            document.body.style.touchAction = 'none';
        } else {
            document.body.style.overflow = 'unset';
            document.body.style.touchAction = 'auto';
        }

        return () => {
            document.body.style.overflow = originalStyle.overflow;
            document.body.style.touchAction = originalStyle.touchAction;
        };
    }, [isOpen]);
};
